import { appsRoutes } from '../../../../app-config';

export function createUrl(app, url) {
    return `${appsRoutes[app]}/${url}`;
}
